import { useState } from 'react'
import { navigate } from 'gatsby-link'
import { clearFormSession } from '@iq-firebolt/client'
import useStepTemplate from 'hooks/useStepTemplate'
import useAnalytics from 'hooks/useAnalytics'

const useCustomSelectStep = ({ fireboltStep, fieldSlug }) => {
	// State
	const [selectedOption, setSelectedOption] = useState(null)

	const { track, setDispatchedEvents } = useAnalytics() || {}

	useStepTemplate({ fireboltStep })

	function formatWebhookResult() {
		const APIresult = fireboltStep?.webhookResult?.processedData || {}
		const isResultEmptyObject = Object.keys(APIresult).length === 0
		const fireboltCS = JSON.parse(localStorage.getItem('firebolt-custom-store'))
		const localResult = isResultEmptyObject ? fireboltCS?.[fieldSlug] : null
		const result = isResultEmptyObject ? localResult : APIresult

		if ((!APIresult || isResultEmptyObject) && !localResult ) {
			navigate('/produto/bb/erro-no-processamento')
			clearFormSession()

			return []
		}

		if (APIresult && !isResultEmptyObject && !localResult) {
			localStorage.setItem(
				'firebolt-custom-store',
				JSON.stringify({...fireboltCS, [fieldSlug]: APIresult})
			)
		}

		switch (fieldSlug) {
			case 'phone_number':
				return result.map((item) => ({
					id: item,
					name: fieldSlug,
					label: item,
					value: item,
				}))
			case 'address':
				return result.map((item) => ({
					id: item.id,
					name: fieldSlug,
					label: item.address,
					value: item.id,
				}))
			default:
				return []
		}
	}

	function handleNext () {
		fireboltStep?.goNextStep({ [fieldSlug]: selectedOption })
	  }

	function handleGoBack () {
		fireboltStep?.goPreviousStep()
	}
	return {
		selectedOption, setSelectedOption,
		formatWebhookResult,
		handleGoBack,
		handleNext
	}
}

export default useCustomSelectStep
